export default __webpack_public_path__ + "static/media/indoor.093bc05a.png";